import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { API } from "@api";
import { Waffles } from "@api/waffles";
import { LoadingPage } from "@components";

interface GlobalProviderProps {
  children: ReactNode;
}

type GlobalContextType = {
  waffles: Waffles;
};

const defaultWaffles = {
  flags: {},
  switches: {
    stakeholder: false,
  },
};

const defaultGlobalContext: GlobalContextType = {
  waffles: defaultWaffles,
};

const mergeContext = (serverContext: GlobalContextType) => {
  return {
    waffles: {
      flags: {
        ...defaultGlobalContext.waffles.flags,
        ...serverContext.waffles.flags,
      },
      switches: {
        ...defaultGlobalContext.waffles.switches,
        ...serverContext.waffles.switches,
      },
    },
  };
};

const GlobalContext = createContext<GlobalContextType>(defaultGlobalContext);

const GlobalProvider = ({ children }: GlobalProviderProps) => {
  const [loading, setLoading] = useState(false);
  const [waffles, setWaffles] = useState<Waffles>(defaultWaffles);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await API.waffles.getWaffles();
      if (response) setWaffles(response);
    } catch (error) {
      // TODO: Handle errors
    } finally {
      setLoading(false);
    }
  };

  const value = mergeContext({ waffles });

  useEffect(() => {
    // Note: need timer for correct order of init requests
    const timer = setTimeout(() => {
      getData();
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  return (
    <GlobalContext.Provider value={value}>
      {loading ? <LoadingPage /> : children}
    </GlobalContext.Provider>
  );
};

const useGlobalContext = () => useContext(GlobalContext);

export { GlobalProvider, useGlobalContext };
